import { Link } from "react-router-dom";
import { useState } from "react";

export const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    if (!password) {
      setErrorMessage("Password is required");
      return false;
    }
    if (password.length < 8) {
      setErrorMessage("Password must be at least 8 characters");
      return false;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const IMG = (imgName) => {
    return `assets/landingpage/images/${imgName}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      // await resetPasswordApi(password);
      // navigate("/login");
    } catch (error) {
      setErrorMessage(error.response?.data?.detail || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="vh-100">
      <div className="d-flex flex-column flex-md-row h-100">
        {/* Left Panel */}
        <div className="d-flex w-58 max-md-w-100 login-banner-container position-relative">
          <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
          <img
              loading="lazy"
              src="assets/landingpage/images/Login.jpg"
              alt="Login illustration"
              className="illustration-image"
              style={{
                mixBlendMode: "multiply",
              }}
            />
          </div>
        </div>

        {/* Right Panel */}
        <div className="flex-grow-1 w-42">
          <main className="d-flex flex-column justify-content-center h-100 bg-white rounded">
          <a
              href="/"
              className="d-flex justify-content-center image-container"
              data-discover="true"
            >
              <img
                loading="lazy"
                src="assets/images/logo.svg"
                alt="Company logo"
                className="z-10  m-0  w-120 md-w-173   company-image"
              />
            </a>
            <h1 className="text-center text-dark fw-bold">Forgot Password</h1>

            <form className="mt-4">
              {/* Password Field */}
              <div className="form__group">
                <input
                  type="password"
                  className="form__field"
                  placeholder="New Password"
                  name="password"
                  id="password"
                  required
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
                <label htmlFor="password" className="form__label">
                  New Password<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src={IMG("lock-sm.svg")}
                  alt=""
                  aria-hidden="true"
                  className="input-icon"
                />
              </div>

              {/* Confirm Password Field */}
              <div className="form__group">
                <input
                  type="password"
                  className="form__field"
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  id="confirmPassword"
                  required
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                />
                <label htmlFor="confirmPassword" className="form__label">
                  Confirm Password<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src={IMG("lock-sm.svg")}
                  alt=""
                  aria-hidden="true"
                  className="input-icon"
                />
              </div>

              <small className="text-muted">(Minimum 8 characters in length)</small>

              {/* Reset Password Button */}
              <button
                type="submit"
                className="btn btn-info text-white rounded-pill w-100 login-button"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
              {loading && (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              )}
            </form>
          </main>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;